import api from './api';

/**
 *
 * @returns {Promise<{
 *  countFiltered?: number
 *  tokens: {
 *      token_id: string
 *      status: 'NOT_REDEEMED' | 'REDEEMED' | 'DISABLED'
 *      date_of_start: null
 *      date_of_end: null
 *      description: string
 *      created_at: string
 *      test_centre_number: string
 *      legacy_number: string
 *      user_id: null
 *      test_group_id: string | null
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#/selected-token-data
 */
export default async function selectedTokensData(selectedIds) {
    const { data } = await api.post('selected-token-data', {
            tokens: selectedIds
        });
    return data;
}